<template>
    <internal>
        <tab-panel :panels="['StudentDetails','LastQualification','Address','Documents']">
            <template #StudentDetails>
                <p class="text-lg font-medium mb-4">Student Details</p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="">
                        <breeze-label :value="'First Name'"/>
                        <breeze-input class="w-full" :value="enquiry.student.first_name" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Middle Name'"/>
                        <breeze-input class="w-full" :value="enquiry.student.middle_name" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Last Name'"/>
                        <breeze-input class="w-full" :value="enquiry.student.last_name" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Mother Name'"/>
                        <breeze-input class="w-full" :value="enquiry.student.mother_name" :disabled="true"/>
                    </div>
                    <div class="col-span-2">
                        <breeze-label :value="'Email'"/>
                        <breeze-input class="w-full" :value="enquiry.student.email" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Mobile'"/>
                        <breeze-input class="w-full" :value="enquiry.student.mobile" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Alternate Mobile'"/>
                        <breeze-input class="w-full" :value="enquiry.student.alternate_mobile" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Blood Group'"/>
                        <breeze-input class="w-full" :value="enquiry.student.blood_group" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Caste Category'"/>
                        <breeze-input class="w-full" :value="enquiry.student.caste_category" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Nationality'"/>
                        <breeze-input class="w-full" :value="enquiry.student.nationality" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Religion'"/>
                        <breeze-input class="w-full" :value="enquiry.student.religion" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Mother Tongue'"/>
                        <breeze-input class="w-full" :value="enquiry.student.mother_tongue" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Gender'"/>
                        <breeze-input class="w-full" :value="enquiry.student.gender" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Martial Status'"/>
                        <breeze-input class="w-full" :value="enquiry.student.martial_status" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Adhaar No'"/>
                        <breeze-input class="w-full" :value="enquiry.student.adhaar_no" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Date of Birth'"/>
                        <breeze-input class="w-full" :value="enquiry.student.date_of_birth" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Parent Mobile'"/>
                        <breeze-input class="w-full" :value="enquiry.student.parent_mobile" :disabled="true"/>
                    </div>
                    <div class="col-span-2">
                        <breeze-label :value="'Parent Alternate Mobile'"/>
                        <breeze-input class="w-full" :value="enquiry.student.parent_alternate_mobile" :disabled="true"/>
                    </div>
                    <div class="col-span-2">
                        <breeze-label :value="'Parent Email'"/>
                        <breeze-input class="w-full" :value="enquiry.student.parent_email" :disabled="true"/>
                    </div>
                </div>
            </template>
            <template #LastQualification>
                <p class="text-lg font-medium mb-4">Last Qualification Details</p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="">
                        <breeze-label :value="'Year'"/>
                        <breeze-input class="w-full" :value="enquiry.student.last_qualification_year" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Percentage'"/>
                        <breeze-input class="w-full" :value="enquiry.student.last_qualification_percentage"
                                      :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Mark'"/>
                        <breeze-input class="w-full" :value="enquiry.student.last_qualification_marks"
                                      :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Educational Gap'"/>
                        <breeze-input class="w-full" :value="enquiry.student.education_gap" :disabled="true"/>
                    </div>
                </div>
            </template>
            <template #Address>
                <p class="text-lg font-medium mb-4">Permanent Address Details</p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 1'"/>
                        <breeze-input class="w-full" :value="enquiry.student.address_line_1" :disabled="true"/>
                    </div>
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 2'"/>
                        <breeze-input class="w-full" :value="enquiry.student.address_line_2" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'City'"/>
                        <breeze-input class="w-full" :value="enquiry.student.city" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'State'"/>
                        <breeze-input class="w-full" :value="enquiry.student.state" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Pincode'"/>
                        <breeze-input class="w-full" :value="enquiry.student.pincode" :disabled="true"/>
                    </div>
                </div>
                <hr class="my-2 border border-gray-300">
                <p class="text-lg font-medium mb-4">Temporary Address Details</p>
                <div class="grid grid-cols-4 gap-4 mb-4">
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 1'"/>
                        <breeze-input class="w-full" :value="enquiry.student.temp_address_line_1" :disabled="true"/>
                    </div>
                    <div class="col-span-4">
                        <breeze-label :value="'Address Line 2'"/>
                        <breeze-input class="w-full" :value="enquiry.student.temp_address_line_2" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'City'"/>
                        <breeze-input class="w-full" :value="enquiry.student.temp_city" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'State'"/>
                        <breeze-input class="w-full" :value="enquiry.student.temp_state" :disabled="true"/>
                    </div>
                    <div class="">
                        <breeze-label :value="'Pincode'"/>
                        <breeze-input class="w-full" :value="enquiry.student.temp_pincode" :disabled="true"/>
                    </div>
                </div>
            </template>
            <template #Documents>
                <p class="text-lg font-medium mb-4">Student Documents</p>
                <div class="grid grid-cols-8 gap-4 mb-4">
                    <a class="col-span-2 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                       :href="doc.file" target="_blank" v-for="doc,index in enquiry.student.documents"
                       :key="index">{{ doc.title }}</a>
                    <p class="text-red-500 font-medium col-span-3" v-if="!enquiry.student.documents.length">Documents
                        not uploaded by student.</p>
                </div>
            </template>
        </tab-panel>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg mb-4">
            <p class="text-lg font-medium mb-4">Admission Processing Fees</p>
            <form @submit.prevent="receiptAction" class="grid grid-cols-8 gap-4 mb-4">
                <div class="col-span-2 pt-1.5">
                    <a class=" w-full inline-flex items-center px-4 py-2
                     bg-gray-800 border border-transparent rounded-md
                      font-semibold text-xs text-white uppercase tracking-widest
                      hover:bg-gray-700 active:bg-gray-900 focus:outline-none
                      focus:border-gray-900 focus:shadow-outline-gray
                      transition ease-in-out duration-150 justify-center text-nowrap"
                       :href="enquiry.transaction.receipt" target="_blank" v-if="enquiry.transaction">View Receipt</a>
                    <p class="text-red-500 font-medium col-span-3" v-else>Receipt not uploaded by student.</p>
                </div>
                <div v-if="enquiry.transaction && enquiry.transaction.status != 'confirmed'">
                    <select
                        required
                        class="mt-1 relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white"
                        v-model="feeform.action">
                        <option value="confirmed">Confirmed</option>
                        <option value="rejected">Rejected</option>
                    </select>
                    <breeze-input-error :message="feeform.errors?feeform.errors.action:''"/>
                </div>
                <div class="col-span-2" v-if="enquiry.transaction && enquiry.transaction.status != 'confirmed'">
                    <breeze-input v-model="feeform.remark" placeholder="Remark" class="w-full m-0"/>
                    <breeze-input-error :message="feeform.errors?feeform.errors.remark:''"/>
                </div>
                <div class="pt-1.5">
                    <breeze-button class="justify-center" type="submit"
                                   v-if="enquiry.transaction && enquiry.transaction.status != 'confirmed'">Save
                    </breeze-button>
                </div>
            </form>
        </div>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg relative"
             v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Enquiry')">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Edit Enquiry</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                @change="updateCourse"
                                label="Academic Year *"
                                :options="allDurations"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.academicyear"
                                :error="form.errors.academicyear"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <FormMultiselect
                                @change="updateCourseYear"
                                label="Course"
                                :options="allCourses"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.course"
                                :error="form.errors.course"
                            />
                        </div>
                        <div class="col-span-2 sm:col-span-2">

                            <FormMultiselect
                                @change="updateCourseBatch"
                                label="Course Year"
                                :options="courseYearsData"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.year"
                                :error="form.errors.year"
                            />

                        </div>
                        <div class="" v-if="(enquiry.transaction && enquiry.transaction.status == 'confirmed')">
                            <breeze-label :value="'Mark as Admission'"/>
                            <breeze-checkbox v-model="form.admission" :checked="form.admission"/>
                            <breeze-input-error :message="form.errors?form.errors.admission:''"/>
                        </div>
                        <div class="col-span-2 sm:col-span-2" v-if="form.admission && form.year">

                            <FormMultiselect
                                label="Course Batch"
                                :options="batchData"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.batch"
                                :error="form.errors.batch"
                            />

                        </div>
                        <div class="col-span-2 sm:col-span-2" v-if="form.admission && form.year">

                            <FormMultiselect
                                label="Admission Year"
                                :options="years"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.admission_year"
                                :error="form.errors.admission_year"
                            />

                        </div>
                    </div>
                    <button-link :href="route('internal.enquiry.list',branchid)"
                                 class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeCheckbox from '@/Components/Checkbox'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import SelectList from '@/Components/SelectList'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import TabPanel from '@/Components/TabPanel'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

export default {
    components: {
        FormMultiselect,
        Internal,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        SelectList,
        Exception,
        Loading,
        BreezeCheckbox,
        TabPanel,
    },
    props: ['enquiry', 'branch', 'durations', 'courses', 'courseyears'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                student: this.enquiry.student,
                academicyear: this.enquiry.academicyear?.id ? {
                    id: this.enquiry.academicyear.id,
                    title: `${this.enquiry.academicyear.start_month} - ${this.enquiry.academicyear.end_month}`
                } : [],
                course: this.enquiry.course,
                year: this.enquiry.courseyear,
                batch: '',
                admission_year: '',
                receipt: this.enquiry.transaction,
                admission: this.enquiry.status === 'admitted' ? true : false
            }),
            feeform: useForm({
                '_method': 'PUT',
                action: '',
                remark: '',
            }),
            branchid: localStorage.branchId,
            coursesData: this.courses,
            courseYearsData: this.courseyears,
            batchData: this.enquiry.courseyear ? this.enquiry.courseyear.batches : [],
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('internal.enquiry.update', [this.branch.id, this.enquiry.id]), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        receiptAction() {
            if (confirm('Are you sure to save this action?')) {
                this.submitFeeForm();
            }
        },
        submitFeeForm() {
            this.feeform.post(route('internal.enquiry.fee.update', [this.branch.id, this.enquiry.id, this.enquiry.transaction.id]), {
                onSuccess: () => {
                    location.reload()
                },
            });
        },
        openPanel(event, panelName) {
            // Declare all variables
            console.log(event);
            var i, tabpanel, tab;

            // Get all elements with class="tabpanel" and hide them
            tabpanel = document.getElementsByClassName("tabpanel");
            for (i = 0; i < tabpanel.length; i++) {
                tabpanel[i].style.display = "none";
            }

            // Get all elements with class="tab" and remove the class "active"
            tab = document.getElementsByClassName("tab");
            for (i = 0; i < tab.length; i++) {
                tab[i].className = tab[i].className.replace(" active", "");
            }

            // Show the current tab, and add an "active" class to the button that opened the tab
            document.getElementById(panelName).style.display = "block";
            event.currentTarget.className += " active";
        },
        updateCourse(value) {
            if (!value?.id) {
                this.form.academicyear = [];
                return;
            }
            window.axios.get(route('internal.enquiry.courses', [this.branchid, this.enquiry.id, value.id]))
                .then((res) => {
                    this.coursesData = res.data;
                    this.form.course = []
                    this.form.year = [];
                    this.form.batch = ''
                });
        },
        updateCourseYear(value) {
            if (!value?.id) {
                this.form.course = [];
                return;
            }
            window.axios.get(route('internal.enquiry.years', [this.branchid, this.enquiry.id, this.form.academicyear.id, value.id]))
                .then((res) => {
                    this.courseYearsData = res.data;
                    this.form.year = [];
                    this.form.batch = ''
                    console.log('ok')
                });
        },
        updateCourseBatch(value) {
            if (!value?.id) {
                this.form.year = [];
                return;
            }
            window.axios.get(route('internal.enquiry.batches', [this.branchid, this.enquiry.id, this.form.academicyear.id, this.form.course.id, value.id]))
                .then((res) => {
                    this.batchData = res.data;
                    this.form.batch = ''
                    console.log('ok')
                });
        }
    },
    computed: {
        allDurations() {
            var durations = [];
            this.durations.forEach(duration => {
                durations.push({id: duration.id, title: duration.start_month + ' - ' + duration.end_month});
            });
            return durations;
        },
        allCourses() {
            var courses = [];
            this.coursesData.forEach(course => {
                courses.push({id: course.id, title: course.title});
            });
            return courses;
        },
        years() {
            var year = new Date().getFullYear();
            var years = [];
            years.push({id: year - 1, title: String(year - 1)})
            years.push({id: year, title: String(year)})
            years.push({id: year + 1, title: String(year + 1)})
            return years;
        }
    }
}
</script>
